import { runtimeEnv } from 'config/runtimeEnv';
import requestInstance from './Request';
import { setCurrentUser } from '../utils/utils';
import { API_ENDPOINT } from './Api';

let env = runtimeEnv('B2B_API_BASE_URL');

export const ourCarApi = async (data) => {
  const url = `${env}${API_ENDPOINT.Dashboard.ourCarApi}`;

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

// export const  cabRideApi = async(data) => {
//   const url = `${env}${API_ENDPOINT.Dashboard.cabRideApi}`

//   const res = await requestInstance.get(
//     url
//   )
//   .catch((err) =>  err.response)
//   return setCurrentUser(res)
// }

// export const  topVendorApi = async(data) => {
//   const url = `${env}${API_ENDPOINT.Dashboard.topVendorApi}`

//   const res = await requestInstance.get(
//     url
//   )
//   .catch((err) =>  err.response)
//   return setCurrentUser(res)
// }

// export const  topSubVendorApi = async(data) => {
//   const url = `${env}${API_ENDPOINT.Dashboard.topSubVendorApi}`

//   const res = await requestInstance.get(
//     url
//   )
//   .catch((err) =>  err.response)
//   return setCurrentUser(res)
// }

// export const  topDriverApi = async(data) => {
//   const url = `${env}${API_ENDPOINT.Dashboard.topDriverApi}`

//   const res = await requestInstance.get(
//     url
//   )
//   .catch((err) =>  err.response)
//   return setCurrentUser(res)
// }

// export const  rideAcceptApi = async(data) => {
//   const url = `${env}${API_ENDPOINT.Dashboard.rideAcceptApi}`

//   const res = await requestInstance.get(
//     url
//   )
//   .catch((err) =>  err.response)
//   return setCurrentUser(res)
// }

// export const  dashboardFeedbackApi = async(data) => {
//   const url = `${env}${API_ENDPOINT.Dashboard.dashboardFeedbackApi}`

//   const res = await requestInstance.get(
//     url
//   )
//   .catch((err) =>  err.response)
//   return setCurrentUser(res)
// }
